import Vue from 'vue'
import App from './App.vue'
import router from './router'
import GoEasy from 'goeasy';

Vue.config.productionTip = false

Vue.prototype.globalData = {
    currentAgent: null
};

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// 从 URL 参数或环境变量获取 GoEasy 配置
const urlParams = new URLSearchParams(window.location.search);
const goEasyHost = urlParams.get('goeasy_host') || 'hangzhou.goeasy.io'; // 应用所在的区域地址: 【hangzhou.goeasy.io |singapore.goeasy.io】
const goEasyAppKey = urlParams.get('goeasy_appkey') || 'BC-c9766d1ce63849b9817edbc7a0c3a195'; // common key

const goEasy = GoEasy.getInstance({
	host: goEasyHost,
	appkey: goEasyAppKey,
	modules: ['im']
});

Vue.prototype.GoEasy = GoEasy;
Vue.prototype.goEasy = goEasy;

